import React from "react"
import * as translations from "constants/translations"
import { Text } from "components/service"

export const enablings = {
  true: <Text value={translations.ENABLED} />,
  false: <Text value={translations.DISABLED} />,
}
